import { components } from 'react-select';
import React from 'react';
import { alpha, Box, Stack } from '@mui/material';
import { FormComponentValue } from 'components/common/form/layout/control';

// Default template for Option, override with props.optionComponent
export const ReactSelectOption = (props: any) => {
    const dataTest = `${props.selectProps?.['data-test']}_option`;

    const value: FormComponentValue = props.data;
    const desc = value.props?.desc;
    const descRight = value.props?.desc_right;

    return (
        <Box data-test={dataTest}>
            <components.Option {...props}>
                <Stack direction={'row'}>
                    {props.data?.props?.displayIcon !== false && props.data.icon && (
                        <Box
                            sx={{
                                mr: 1,
                                width: '16px',
                                height: '16px',
                                display: 'inline-flex',
                                pt: '1px',
                                fontSize: props.data.props.icon.type == 'mi' ? '16px' : '14px',
                            }}
                        >
                            {props.data.icon}
                        </Box>
                    )}
                    <Stack flexGrow={1}>
                        <Box>{props.children}</Box>
                        {desc && (
                            <Box sx={{ pt: '2px', color: (theme) => alpha(theme.palette.text.primary, 0.8) }}>
                                {desc}
                            </Box>
                        )}
                    </Stack>
                    {descRight && (
                        <Box sx={{ pl: 1, color: (theme) => alpha(theme.palette.text.primary, 0.64) }} flexShrink={0}>
                            {descRight}
                        </Box>
                    )}
                </Stack>
            </components.Option>
        </Box>
    );
};
